module.exports = __webpack_public_path__ + "img/about1.165f981b.png";